module.exports = __webpack_public_path__ + "static/IMG_2349-8e2946695b6202b80135653c20c722e3.jpg";